"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexCenter, SkeletonBlock, SkeletonLine, TableCell, TableRow, tableRowSizeVariants, useTable } from "@opensea/ui-kit";
import { range } from "es-toolkit/math";
import { COLLECTION_HOLDERS_TABLE_COLUMN_CLASSNAMES, COLLECTION_HOLDERS_TABLE_COMPACT_COLUMN_CLASSNAMES } from "./styles";
export function CollectionHoldersTableSkeletonRow() {
  const $ = _c(42);
  const {
    size
  } = useTable();
  let COLUMN_CLASSNAMES;
  let T0;
  let T1;
  let T2;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== size) {
    const {
      image
    } = tableRowSizeVariants({
      size
    });
    COLUMN_CLASSNAMES = size === "md" ? COLLECTION_HOLDERS_TABLE_COMPACT_COLUMN_CLASSNAMES : COLLECTION_HOLDERS_TABLE_COLUMN_CLASSNAMES;
    T2 = TableRow;
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <SkeletonLine className="w-1/2" />;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    if ($[12] !== COLUMN_CLASSNAMES.wallet) {
      t3 = <TableCell className={COLUMN_CLASSNAMES.wallet}>{t6}</TableCell>;
      $[12] = COLUMN_CLASSNAMES.wallet;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <SkeletonLine className="w-1/2" />;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    if ($[15] !== COLUMN_CLASSNAMES.owned) {
      t4 = <TableCell className={COLUMN_CLASSNAMES.owned}>{t7}</TableCell>;
      $[15] = COLUMN_CLASSNAMES.owned;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    let t8;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <SkeletonLine className="w-1/2" />;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    if ($[18] !== COLUMN_CLASSNAMES.percent) {
      t5 = <TableCell className={COLUMN_CLASSNAMES.percent}>{t8}</TableCell>;
      $[18] = COLUMN_CLASSNAMES.percent;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    T1 = TableCell;
    t2 = COLUMN_CLASSNAMES.items;
    T0 = FlexCenter;
    t0 = "gap-2";
    t1 = range(5).map(index => <SkeletonBlock className={image()} key={index} />);
    $[0] = size;
    $[1] = COLUMN_CLASSNAMES;
    $[2] = T0;
    $[3] = T1;
    $[4] = T2;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    COLUMN_CLASSNAMES = $[1];
    T0 = $[2];
    T1 = $[3];
    T2 = $[4];
    t0 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
  }
  let t6;
  if ($[20] !== T0 || $[21] !== t0 || $[22] !== t1) {
    t6 = <T0 className={t0}>{t1}</T0>;
    $[20] = T0;
    $[21] = t0;
    $[22] = t1;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== T1 || $[25] !== t2 || $[26] !== t6) {
    t7 = <T1 className={t2}>{t6}</T1>;
    $[24] = T1;
    $[25] = t2;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SkeletonLine className="w-1/2" />;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== COLUMN_CLASSNAMES.value) {
    t9 = <TableCell className={COLUMN_CLASSNAMES.value}>{t8}</TableCell>;
    $[29] = COLUMN_CLASSNAMES.value;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SkeletonLine className="w-1/2" />;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== COLUMN_CLASSNAMES.portfolio) {
    t11 = <TableCell className={COLUMN_CLASSNAMES.portfolio}>{t10}</TableCell>;
    $[32] = COLUMN_CLASSNAMES.portfolio;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== T2 || $[35] !== t11 || $[36] !== t3 || $[37] !== t4 || $[38] !== t5 || $[39] !== t7 || $[40] !== t9) {
    t12 = <T2>{t3}{t4}{t5}{t7}{t9}{t11}</T2>;
    $[34] = T2;
    $[35] = t11;
    $[36] = t3;
    $[37] = t4;
    $[38] = t5;
    $[39] = t7;
    $[40] = t9;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  return t12;
}